module.exports = __webpack_public_path__ + "static/media/homepage.9041583a.png";